import React from "react";
import { useDimensions } from "../../../Util";
import { BsFillHouseFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";


const ComingSoon = () => {

    const {w,h} = useDimensions();
    const navigate = useNavigate();

    const Styles={
        containerRow:{
            display:"flex",
            justifyContent:"center",
            alignItems:"center"
        },
        containerCol:{
            width:"100%",
            height:"100%",
            display:"flex",
            justifyContent:"center",
            alignItems:"center",
            flexDirection:"column"
        },
        coming:{
            background:"#FF2E63",
            display:"flex",
            justifyContent:"center",
            alignItems:"center"
        },
        soon:{
            background:"#00ADB5",
            display:"flex",
            justifyContent:"center",
            alignItems:"center"
        },
        xlargeTextBold: {
            fontFamily: "Candal",
            fontSize: w > h ? "clamp(38px,4vw,50px)" : "clamp(38px,4vh,50px)"
        },
        mediumTextNormal: {
            fontFamily: "Outfit",
            fontSize: w > h ? "clamp(14px,1.25vw,18px)" : "clamp(14px,1.25vh,18px)",
            textAlign:"justify"
        },
        btnHome: {
            padding: "10px",
            background: "#00ADB5",
            color: "#EEEEEE",
            border: "2px solid #EEEEEE",
            borderRadius: w > h ? w : h,
            fontSize: 2.75 * h,
            fontFamily: "Outfit",
            marginInline: "5px",
            cursor: "pointer",
            fontWeight:600,
            marginTop:4*h
        },

    }

    const icon = "";
    const handleclick=(icon)=>{
        navigate(icon)
    }

    return <div style={Styles.containerCol}>
        <div style={Styles.containerRow}>
            <div style={Styles.coming}>
                <p style={Styles.xlargeTextBold}>COMING</p>
            </div>
            <div style={Styles.soon}>
                <p style={Styles.xlargeTextBold}>SOON</p>
            </div>
        </div>
        <div style={{width:"75%"}}>
            <p style={Styles.mediumTextNormal}> 
            This is a collaborative project driven by the crowd, and we’re excited to 
            announce that the code will be made open-source on April 22nd, coinciding with
             the release of the MVP. We value your feedback and welcome any suggestions 
             for improvements. We’re also eager to hear your perspective! If you’re 
             interested in contributing code, offering assistance, or getting involved 
             in any way, please don’t hesitate to reach out as we prepare for the 
             launch of this exciting app.
            </p>
        </div>
        <div>
            <button style={Styles.btnHome}><BsFillHouseFill style={icon} onClick={() => handleclick("/")} /></button>
        </div>
    </div>
}

export default ComingSoon;